import moment from "moment";
import { TableColumn } from "../../../components/table";

export const AVAILABLE_COLUMN_SOH: TableColumn[] = [
  {
    id: "SKU",
    dataIndex: "SKU",
  },
  {
    id: "Barcode",
    dataIndex: "Barcode",
  },
  {
    id: "Brand",
    dataIndex: "Brand",
  },
  {
    id: "NameCn",
    dataIndex: "Name",
    header: "Product",
  },
  {
    id: "NameEn",
    dataIndex: "NameEn",
    header: "ProductEn",
  },
  {
    id: "IPName",
    dataIndex: "IPName",
    header: "IP",
  },
  {
    id: "Category",
    dataIndex: "Category",
  },
  {
    id: "Scale",
    dataIndex: "Scale",
    dataAlign: "center",
  },
  // {
  //   id: "Quantity",
  //   header: "Quantity",
  //   dataIndex: "StockQty",
  //   dataAlign: "right",
  //   render: (obj, row) => `${row.AvailableQty}/${row.StockQty}`,
  // },
  {
    id: "AvailableQty",
    header: "Available Qty",
    dataIndex: "AvailableQty",
    dataAlign: "right",
  },
  {
    id: "StockQty",
    header: "Total Qty",
    dataIndex: "StockQty",
    dataAlign: "right",
  },
  {
    id: "PendingQty",
    header: "Pending Qty",
    dataIndex: "PendingQty",
    dataAlign: "right",
  },
];

export const EXPORT_COLUMN_SOH: TableColumn[] = [
  {
    id: "SKU",
    dataIndex: "SKU",
  },
  {
    id: "Barcode",
    dataIndex: "Barcode",
  },
  {
    id: "NameCn",
    dataIndex: "Name",
    header: "Product",
  },
  {
    id: "NameEn",
    dataIndex: "NameEn",
    header: "ProductEn",
  },
  {
    id: "IPName",
    dataIndex: "IPName",
    header: "IP",
  },
  {
    id: "Category",
    dataIndex: "Category",
  },
  {
    id: "Scale",
    dataIndex: "Scale",
    dataAlign: "center",
  },
  {
    id: "AvailableQty",
    header: "Quantity Ava.",
    dataIndex: "AvailableQty",
    dataAlign: "right",
  },
  {
    id: "StockQty",
    header: "Quantity Total",
    dataIndex: "StockQty",
    dataAlign: "right",
  },
  {
    id: "PendingQty",
    header: "Pending Qty",
    dataIndex: "PendingQty",
    dataAlign: "right",
  },
];

export const DEFAULT_COLUMN_SETTING_SOH: string[] = ["Name", "SKU", "Barcode", "Scale", "Quantity"];

//SubTable:
export const AVAILABLE_SUBTABLE_COLUMN_SOH: TableColumn[] = [
  {
    id: "InboundDate",
    dataIndex: "InboundDate",
    header: "InboundDate",
    render: (obj) => moment(obj).format("yyyy-MM-DD"),
  },
  {
    id: "ASNNo",
    dataIndex: "ASNNo",
  },
  {
    id: "WholesaleOrder",
    dataIndex: "WholesaleOrder",
  },
  {
    id: "BatchNo",
    dataIndex: "BatchNo",
  },
  {
    id: "AvailableQty",
    dataIndex: "AvailableQty",
  },
  {
    id: "ExpireDate",
    dataIndex: "ExpireDate",
    header: "ExpireDate",
    render: (obj) => moment(obj).format("yyyy-MM-DD"),
  },
];

export const DEFAULT_SUBTABLE_COLUMN_SETTING_SOH: string[] = [
  "ASNNo",
  "WholesaleOrder",
  "BatchNo",
  "AvailableQty",
  "InboundDate",
  "ExpireDate",
];
